(function () {
    var clampSections = document.querySelectorAll(".fade-in-and-out-js");
    if (clampSections.length) {
        var animateInAndOut_1 = function () {
            var clamp = function (num, min, max) {
                return Math.max(min, Math.min(num, max));
            };
            var pixels = window.pageYOffset;
            clampSections.forEach(function (section) {
                var topSection = section.offsetTop;
                var midSection = topSection + (section.offsetHeight / 2);
                var opacity = 0;
                var timeline = clamp((pixels - (midSection - (window.innerHeight + 200))) * 0.002, 0, 1);
                timeline -= clamp((pixels - (midSection - (window.innerHeight * 0.4))) * 0.002, 0, 1);
                opacity = timeline;
                section.style.opacity = opacity.toString();
            });
        };
        if (document.querySelector("section.fade-in-and-out-js img")) {
            document.querySelector("section.fade-in-and-out-js img").addEventListener('lazyloaded', function (e) {
                animateInAndOut_1();
            });
        }
        else {
            animateInAndOut_1();
        }
        window.addEventListener("scroll", function () {
            animateInAndOut_1();
        });
    }
})();
